import { render, staticRenderFns } from "./ParticipantsAgps.vue?vue&type=template&id=f115a8da&scoped=true"
import script from "./ParticipantsAgps.vue?vue&type=script&lang=js"
export * from "./ParticipantsAgps.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsAgps.vue?vue&type=style&index=0&id=f115a8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f115a8da",
  null
  
)

export default component.exports